(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const group = this.querySelector('[data-announcement-messages]');
        const viewport = this.querySelector('.announcement__viewport');
        const copy = group.cloneNode(true);
        copy.removeAttribute('data-announcement-messages');
        copy.setAttribute('data-announcement-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((item) => item.removeAttribute('data-shopify-editor-block'));
        copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        group.after(copy);
        this.setAttribute('data-ready', '');
        this.querySelector('[data-announcement-close]')?.addEventListener('click', () => this.remove(), options);
        this.addEventListener('shopify:block:select', () => this.setAttribute('data-editor-selected', ''), options);
        this.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-editor-selected'), options);
        this.observer = new ResizeObserver(() => {
          this.style.setProperty('--marquee-width', `${viewport.clientWidth}px`);
          this.style.setProperty('--marquee-duration', `${group.scrollWidth / (Number(this.dataset.speed) || 40)}s`);
        });
        this.observer.observe(viewport);
        this.observer.observe(group);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.querySelector('[data-announcement-copy]')?.remove();
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  if (!customElements.get('recommendation-carousel')) {
    customElements.define('recommendation-carousel', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-carousel-rail]');
        if (!this.rail) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const controls = this.querySelector('.recommendation-carousel__controls');
        const previous = this.querySelector('[data-carousel-previous]');
        const next = this.querySelector('[data-carousel-next]');
        const update = () => {
          const maximum = this.rail.scrollWidth - this.rail.clientWidth;
          const position = Math.abs(this.rail.scrollLeft);
          controls.hidden = maximum <= 2;
          previous.disabled = position <= 2;
          next.disabled = position >= maximum - 2;
        };
        const move = (direction) => {
          const card = this.rail.firstElementChild;
          if (!card) return;
          const styles = getComputedStyle(this.rail);
          const step = card.getBoundingClientRect().width + parseFloat(styles.columnGap || 0);
          const count = Math.max(1, Math.floor((this.rail.clientWidth + parseFloat(styles.columnGap || 0)) / step));
          this.rail.scrollBy({ left: direction * step * count * (styles.direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        this.rail.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.rail);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
